<template>
  <div class='info-box' @click='toggleBubble'>
    <div class='circle'>
      i
    </div>
    <div class='box' v-if='isOpen === true && true === false'>
      <div class='left-side'>
        <div class='top'></div>
        <div class='arrow'></div>
        <div class='bottom'></div>
      </div>
      <div class='text'>
        <div v-html="text"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'infobox',
  data () {
    return {
      isOpen: true
    }
  },
  props: ['text'],
  computed: {
  },
  methods: {
    toggleBubble () {
      //  this.isOpen = !this.isOpen
      this.$store.commit('interupt', this.text)
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .info-box {
    position: absolute;
    top: 0px; 
    left: 0px;
    width: calc(100% - 15px);
    max-width: 600px;
    z-index: 9999;
    color: #fff;
  }
  .box {
    position: absolute;
    left: 89px;
    top: 15px;
    width: calc(100% - 89px);
    min-height: 47px;
    border-right: 2px solid #fff;
    border-top: 2px solid #fff;
    border-bottom: 1px solid #fff;
  }
  .text {
    padding: 13px 16px 12px 16px;
    width: auto;
    font-size: 16px;
    text-align: left;
  }
  .left-side {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 40px;
    display: flex;
    flex-flow: column;
  }
  .left-side .top {
    flex: 0 1 13px;
    border-left: 1px solid #fff;
  }
  .left-side .arrow {
    position: relative;
    left: -14px;
    flex: 0 1 21px;
    background-image: url('./../assets/bubble_arrow.svg');
    background-repeat: no-repeat;
  }
  .left-side .bottom {
    flex: 1 1 auto;
    border-left: 1px solid #fff;
  }
  .circle {
    border-radius: 100%;
    border: 0px solid #4d4dc1;
    position: absolute;
    top: 22px;
    line-height: 36px;
    left: 24px;
    color: #fff;
    cursor: pointer;
    font-size: 20px;
    height: 36px;
    width: 36px;
    font-weight: bold;
    background-color: #2f4efd;
    background-color: #fdcc73;
  }
</style>



// WEBPACK FOOTER //
// Infobox.vue?3c31e2c5